(function () {
  "use strict";

  angular.module("sempraWebapp").filter("codeToDayName", codeToDayName);

  /** @ngInject */
  function codeToDayName($translate) {
    return function (input) {
      switch (input) {
        case 0:
          return $translate.instant('MON');
        case 1:
          return $translate.instant('TUE');
        case 2:
          return $translate.instant('WED');
        case 3:
          return $translate.instant('THU');
        case 4:
          return $translate.instant('FRI');
        case 5:
          return $translate.instant('SAT');
        case 6:
          return $translate.instant('SUN');
        case 7:
          return $translate.instant('HOLIDAY');
      }
    };
  }
})();
